<template>
    <div class="tree-box">
        <el-select
            ref="treeSelect"
            style="width: 100%"
            v-model="valueLabel"
            :clearable="true"
            :placeholder="placeholder"
            :multiple="multiple"
            filterable
            :filter-method="filterable"
            @clear="handleClear"
            @remove-tag="handleRemoveTag"
        >
        <el-option hidden value="value" label="label">
        </el-option>
            <el-tree
                ref="treeSelectTree"
                :accordion="true"
                :data="treeData"
                :props="props"
                :node-key="props.value"
                :highlight-current="!multiple"
                :show-checkbox="multiple"
                :check-strictly="true"
                :load="loadNode"
                :lazy="true"
                @node-click="handleNodeClick"
                @check="handleNodeCheckbox"
                :filter-node-method="filterNode"
            />
    </el-select>
    </div>
</template>
<script>
import { debounce } from '@/utils'
export default {
    name: "OrgTreeSelect",
    props: {
        disabled: {
            type: Boolean,
            default: false,
        },
        clearable: {
            type: Boolean,
            default: true,
        },
        limits: {
            type: [Array, Boolean],
            default: false,
        },
        placeholder: {
            type: String,
            default: '请选择',
        },
        value: {
            type: [Array],
            default: () => [],
        },
        multiple: {
            type: Boolean,
            default: true
        },
    },
    data() {
        return {
            valueLabel: [],
            treeData: [],
            checkedNodes: [],
            props: {
                value: 'value',
                label: 'label',
                children: 'children',
                isLeaf: 'isLeaf'
            },
            multipleLimit: 15
        }
    },
    watch: {
        value: {
            handler(newVal, oldVal) {
                if (newVal !== oldVal) {
                    this.init()
                }
            }
        },
    },
    mounted() {
        this.init()
    },
    methods: {
        init() {
            if (Array.isArray(this.value)) {
                this.checkedNodes = this.value
            } else {
                this.checkedNodes = []
            }
            if (this.multiple) {
                this.checkedNodes.map(item => {
                    this.$refs.treeSelectTree.setChecked(item.deptCode, true, false)
                })
            } else {
                this.$refs.treeSelectTree.setCurrentKey(this.checkedNodes.length > 0 ? this.checkedNodes[0] : undefined)
            }
            this.initValueLabel()
        },
        initValueLabel() {
            const labels = this.checkedNodes.map(item => item.label)
            if (this.multiple) {
                this.valueLabel = labels            
            } else {
                this.valueLabel = labels.length > 0 ? labels[0] : undefined
            }
        },
        handleClear() {
            this.valueLabel = []
            this.checkedNodes = []
            if (this.multiple) {
                this.$refs.treeSelectTree.setCheckedKeys([])
            } else {
                this.$refs.treeSelectTree.setCurrentKey(null)
            }
            this.$emit('input', this.checkedNodes)
        },
        /* 树节点点击事件 */
        handleNodeClick(data, node) {
            if (!this.multiple) {
                this.checkedNodes = [data]
                this.valueLabel = data.label
            }
            if(node.childNodes){
                node.expanded = true
            }
            this.$emit('input', this.checkedNodes)
        },
        handleNodeCheckbox(data, node) {
            const { checkedNodes } = node
            if (this.multiple) {
                if (this.multipleLimit >= checkedNodes.length) {
                    this.checkedNodes = checkedNodes
                    this.valueLabel = checkedNodes.map(i => i.label)
                } else {
                    this.$refs.treeSelectTree.setChecked(data, false, true)
                    this.$message.error('最多选择' + this.multipleLimit + '项')
                }
            }
            this.$emit('input', this.checkedNodes)
        },
        handleRemoveTag(tag) {
            const node = this.checkedNodes.find(item => item.label === tag)
            if (node) {
                this.$refs.treeSelectTree.setChecked(node.value, false, true)
            }
            this.checkedNodes = this.$refs.treeSelectTree.getCheckedNodes()
            this.$emit('input', this.checkedNodes)
        },
        loadNode(node, resolve) {
            if(node.level === 0) {
                this.getOrgData(undefined, resolve)
            }
            if(node.level >= 1) {
                const { data: { deptCode } } = node
                this.getOrgData(deptCode, resolve)
            }
        },
        getOrgData(deptCode, resolve) {
            const { option: { api, config } } = this.$attrs
            if (!api) return 
            const { getOrgTree } = api   
            getOrgTree && getOrgTree({
                parentCode: deptCode || config.VUE_APP_DEPTCODE
            }).then(res => {
                const orgList = res.data.map(item => ({
                    deptName: item.level === 2 ? item.parentName + item.deptName : item.deptName,
                    deptCode: item.deptCode,
                    deptPath: item.path,
                    label: item.level === 2 ? item.parentName + item.deptName : item.deptName,
                    value: item.deptCode,
                    isLeaf: item.leaf,
                    children: [],
                    id: item.id
                }))
                
                resolve(orgList)
            })
        },
        /* 树filter方法 */
        filterNode(value, data) {
            if (!value) return true
            return data[this.props.label].indexOf(value) !== -1
        },
        filterable: debounce( function(keyWords) {
            // 之后可以加入全局搜索改变treeData
            // 暂时支持多选
            if(this.multiple) {
                this.$refs.treeSelectTree.filter(keyWords)
            }
        }, 500)
    }
}
</script>